import type {
  BattalionPulseResponse,
  BudgetVsActualRow,
  DashboardSummary,
  MonthlyFlowDashboardResponse,
  PrivateSpotlight,
  SubHeadSpendPoint,
} from '@cosvision/shared';
import { request } from '../api.js';

export function getDashboardSummary(): Promise<DashboardSummary> {
  return request<DashboardSummary>('get', '/dashboard/summary');
}

export function getFundSpotlight(fundCode = 'PVT'): Promise<PrivateSpotlight> {
  return request<PrivateSpotlight>('get', '/dashboard/private-spotlight', undefined, {
    params: { fundCode },
  });
}

export function getMonthlyFlow(
  fundId: string,
  months: number,
): Promise<MonthlyFlowDashboardResponse> {
  return request<MonthlyFlowDashboardResponse>('get', '/dashboard/monthly-flow', undefined, {
    params: { fundId, months },
  });
}

export function getSubHeadSpend(fundId: string, fyYear: number): Promise<SubHeadSpendPoint[]> {
  return request<SubHeadSpendPoint[]>('get', '/dashboard/subhead-spend', undefined, {
    params: { fundId, fyYear },
  });
}

export function getBudgetVsActual(fundId: string, fyYear: number): Promise<BudgetVsActualRow[]> {
  return request<BudgetVsActualRow[]>('get', '/dashboard/budget-vs-actual', undefined, {
    params: { fundId, fyYear },
  });
}

export function getBattalionPulse(): Promise<BattalionPulseResponse> {
  return request<BattalionPulseResponse>('get', '/dashboard/battalion-pulse');
}
